import type { IPublicationExtended } from '@typings/api/IPublication';
import { apiRequest } from '@client/lib/apiRequest';
import type { IPublicationFilters } from '@typings/IPublicationFilters';
import type { IApiList } from '@typings/IApiList';

export async function requestItems(
    params: IPublicationFilters,
    offset: number,
): Promise<IApiList<IPublicationExtended>> {
    const response = await apiRequest<IApiList<IPublicationExtended>>('searchPublications', { params, offset });

    return {
        items: response.ok ? response.result.items : [],
        count: response.ok ? response.result.count : 0,
    };
}
